import { render, staticRenderFns } from "./ManualTransactionLimitsView.vue?vue&type=template&id=39c51e7e&scoped=true&"
import script from "./ManualTransactionLimitsView.vue?vue&type=script&lang=js&"
export * from "./ManualTransactionLimitsView.vue?vue&type=script&lang=js&"
import style0 from "./ManualTransactionLimitsView.vue?vue&type=style&index=0&id=39c51e7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c51e7e",
  null
  
)

export default component.exports